/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const InvoiceBody = styled.div`
	margin: auto;
	background: #fff;
	border-radius: 20px;
	max-width: 430px;
`;

export const InvoiceContainer = styled.div`
	max-width: 415px;
	margin: auto;
	min-height: 78vh;
	padding: 20px;
`;

export const LogoContainer = styled.div`
	width: 100%;
	height: 72px;
	display: flex;
	justify-content: center;
`;

export const Logo = styled.div`
	width: ${(props) => (props.hasImage ? '100px' : '0px')}
	height: ${(props) => (props.hasImage ? '100px' : '0px')}
	margin-top: -20px;
	background-size: 100px;
	background-position: center center;
	background-repeat: no-repeat;
`;

export const TopSection = styled.div`
	margin-top: 50px;
	margin-bottom: 20px;
`;

export const BusinessName = styled.div`
	font-size: 18px;
	font-weight: 600;
	color: hsla(0, 0%, 10%, 0.9);
	display: flex;
	justify-content: center;
`;

export const Address = styled.div`
	font-size: 15px;
	display: flex;
	justify-content: center;
`;

export const MiddleSection = styled.div`
	margin-top: 20px;
	margin-bottom: 20px;
`;

export const Amount = styled.div`
	font-size: 40px;
	color: hsla(0, 0%, 10%, 0.9);
	font-weight: 600;
	letter-spacing: -0.03rem;
	line-height: normal;
	padding-bottom: 5px;
	display: flex;
	justify-content: center;
`;

export const TotalAmount = styled.div`
	font-size: 16px;
	color: hsla(0, 0%, 10%, 0.9);
`;

export const ConvenienceFee = styled.div`
	font-size: 16px;
	color: hsla(0, 0%, 10%, 0.9);
`;

export const Date = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: hsla(0, 0%, 10%, 0.9);
	display: flex;
	justify-content: center;
`;

export const Description = styled.div`
	padding-bottom: 5px;
	display: flex;
	justify-content: center;
`;

export const PaymentSuccess = styled.div`
	padding-bottom: 5px;
	display: flex;
	justify-content: center;
`;

export const BottomSection = styled.div`
	margin-top: 20px;
	margin-bottom: 20px;
`;

export const Branding = styled.a`
	color: #9e9e9e;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	font-size: 12px;
	padding-bottom: 10px;

	@media (min-width: 320px) {
		padding-bottom: 10px;
	}
`;



// WEBPACK FOOTER //
// ./src/components/styled-components/index.js